export default "__VITE_ASSET__BVGO_Dfz__"